
export type RoleMenuItem = {
  label: string;
  path: string;
  roles: string[]; // list of roles allowed to see this item
};

export const roleMenuItems: RoleMenuItem[] = [
  // ADMIN
  { label: "Manage Candidates", path: "/admin/manage-candidates", roles: ["ADMIN"] },
  { label: "Manage E-book users", path: "/admin/ebook-users", roles: ["ADMIN"] },
  { label: "Manage Customers", path: "/admin/manage-customers", roles: ["ADMIN"] },
  { label: "HR Dashboard", path: "/admin/hr", roles: ["ADMIN"] },
  { label: "Exams", path: "/admin/exams", roles: ["ADMIN"] },
  { label: "Front Desk", path: "/admin/front-desk", roles: ["ADMIN"] },
  { label: "Trainees", path: "/admin/manage-trainees", roles: ["ADMIN"] },
  { label: "Send Notification", path: "/admin/send-email", roles: ["ADMIN"] },

  // PROCTOR
  { label: "Manage Exams", path: "/proctor/manage-exam", roles: ["PROCTOR"] },

  // FRONT_DESK
  { label: "Front Desk", path: "/front-desk", roles: ["FRONT_DESK"] },

  // EXAMINERS
  {
    label: "Examiner Dashboard",
    path: "/examiner-dashboard",
    roles: [
      "EXAMINER_RWO",
      "EXAMINER_ITWO",
      "EXAMINER_HRWOA",
      "EXAMINER_HRWOB",
      "EXAMINER_HRWOC",
      "EXAMINER_HRWOD",
      "EXAMINER_DWO",
      "EXAMINER_AWO",
    ],
  },

  // HR 
  { label: "HR Dashboard", path: "/hr", roles: ["HRWO"] },
  { label: "Employee Registration", path: "/hr/register", roles: ["HRWO"] },
  { label: "Employees List", path: "/hr/employees-list", roles: ["HRWO"] },
  { label: "Generate Letters", path: "/hr/letters", roles: ["HRWO"] },
  { label: "Attendance", path: "/hr/attendance", roles: ["HRWO"] },
  { label: "Salary", path: "/hr/salary", roles: ["HRWO"] },
  { label: "Meetings", path: "/hr/meetings", roles: ["HRWO"] },
  { label: "Announcements", path: "/hr/announcements", roles: ["HRWO"] },
];
